import { ArticleHeading2, Modal, useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import * as React from 'react';
import { BuyWithCian } from '../../components/BuyWithCian';
import { QualityModal } from '../../components/QualityModal';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { clickBuyerAgentModal, clickBuyerGarantLink } from '../../utils/tracking';

export const BuyWithCianContainer: React.FC = () => {
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false);

  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  const { custom } = useApplicationContext();

  const ItemTitle = useMemo(() => (deviceType === 'desktop' ? ArticleHeading2 : ArticleHeading2), [deviceType]);

  const handleModalOpen = React.useCallback(() => {
    clickBuyerAgentModal(custom);
    setModalOpen(true);
  }, [custom]);

  const handleModalClose = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <BuyWithCian
        device={deviceType}
        onModalClick={handleModalOpen}
        ItemTitle={ItemTitle}
        onLinkClick={() => clickBuyerGarantLink(custom, 'SafeDealCertificateExample')}
      />

      <Modal open={isModalOpen} onOpenChange={handleModalClose} size="M">
        <QualityModal onClick={handleModalClose} isPhone={isPhone} />
      </Modal>
    </>
  );
};
